/**
 * @file 스마트스쿠터 화면 Data
 */

import { URL, COMPANY_NAME_KO } from 'utils/Utils'

/**
 * @constant SCOOTER_TYPE_INFO 스마트스쿠터 종류
 * @type imgUrl 스쿠터 이미지 url
 * @type name 스크터 이름
 * @type sub 스쿠터 sub text
 * @type url 스쿠터 url
 */
export const SCOOTER_TYPE_INFO = [
    {
        imgUrl: require('assets/images/scooter/m7.png'),
        name: 'EV-C1',
        sub: 'EV-C1',
        url: URL.SCOOTER.EV_C1,
    },
    {
        imgUrl: require('assets/images/scooter/m1.png'),
        name: '고고로 S2',
        sub: '한계를 뛰어넘는 특별함',
        url: URL.SCOOTER.S2,
    },
    {
        imgUrl: require('assets/images/scooter/m2.png'),
        name: '고고로 2 플러스',
        sub: '안정적인 승차감',
        url: URL.SCOOTER.PLUS,
    },
    {
        imgUrl: require('assets/images/scooter/m3.png'),
        name: '고고로 2 유틸리티',
        sub: '비즈니스를 위한 선택',
        url: URL.SCOOTER.UTILITY,
    },
    // {
    //     imgUrl: require('assets/images/scooter/m5.png'),
    //     name: '고고로 VIVA XL',
    //     sub: '궁극의 편안함',
    //     url: URL.SCOOTER.XL,
    // },
    // {
    //     imgUrl: require('assets/images/scooter/m6.png'),
    //     name: '고고로 VIVA MIX',
    //     sub: '나만의 스타일',
    //     url: URL.SCOOTER.MIX,
    // },
    /* {
    imgUrl: require("assets/images/scooter/m4.png"),
    name: "고고로 VIVA",
    sub: "일상 속 특별한 주행",
    url: URL.SCOOTER.VIVA,
  }, */
]

/**
 * @constant SCOOTER_MAIN_DESC_INFO 스마트스쿠터 메인화면 desc data 종류
 * @type desc_title 메인화면 desc title text
 * @type desc_sub 메인화면 desc sub text
 * @type img_desc 메인화면 desc img 관련 영역별 Data
 * @type imgUrl 메인화면 desc img 관련 이미지 url
 * @type title 메인화면 desc img 관련 이미지 title text
 * @type sub 메인화면 desc img 관련 이미지 sub text
 */
export const SCOOTER_MAIN_DESC_INFO = [
    {
        desc_title: `스마트하고 편리한 ${COMPANY_NAME_KO} App`,
        desc_sub: '',
        img_desc: [
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide1-photo1.png'),
                title: '스마트한 보안 기능',
                sub: 'Face-ID 및 스마트 키를 통해 차량을 안전하게 보호할 수 있습니다',
            },
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide1-photo2-eng.png'),
                title: '스마트한 차량제어',
                sub: '스마트 어플리케이션을 사용해 편리한 기능을 경험해보세요',
            },
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide1-photo3.jpeg'),
                title: '최적화된 IQ 시스템',
                sub: '지속적으로 업데이트되는 IQ 시스템으로 더 편리한 서비스를 경험해보세요.',
            },
        ],
    },
    {
        desc_title: '누구나 손쉽게 이용가능한 서비스',
        desc_sub: '',
        img_desc: [
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide2-photo1.png'),
                title: 'Swap & Go',
                sub: '단 15초면 배터리 교환이 가능합니다.',
            },
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide2-photo2.png'),
                title: 'Smart Key',
                sub: '스마트 키나 애플리케이션을 통해 간편한 잠금 해제가 가능합니다',
            },
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide2-photo3.jpeg'),
                title: 'Reverse Mode',
                sub: '편리한 후진 기능을 지원합니다.',
            },
        ],
    },
    {
        desc_title: '차별화된 주행 성능',
        desc_sub: '',
        img_desc: [
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide3-photo1.png'),
                title: '거리의 한계를 뛰어넘다',
                sub: '언제 어디서든 배터리를 교환하여 더욱 먼 거리를 주행하세요',
            },
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide3-photo2.png'),
                title: '주행을 더 유연하게',
                sub: '출력과 속도를 자유롭게 설정하여 유연하고 편안한 주행을 즐겨보세요.',
            },
            {
                imgUrl: require('assets/images/scooter/img-scooter-slide3-photo3.jpeg'),
                title: '안전한 주행 성능',
                sub: '풀 LED 라이트, SBS/ABS 브레이크, 차량 진단 시스템',
            },
        ],
    },
]

/**
 * @constant ENDLESS_LIMITS_SWIPER_INFO ev-c1 화면 스와이퍼
 * @type imgUrl 이미지 url
 * @type title 제목
 * @type desc desc
 */
export const ENDLESS_LIMITS_SWIPER_INFO = [
    {
        imgPcUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pc_1.png'),
        imgPadUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pad_1.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_three_swiper_mobile_1.png'),
        title: '공기역학적인 디자인',
        desc: '공기마찰을 최소화한 프레임 디자인과<br/>최적의 중량 밸런스로 안정적인 수행을 가능하게 합니다.',
    },
    {
        imgPcUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pc_2.png'),
        imgPadUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pad_2.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_three_swiper_mobile_2.png'),
        title: '노출형 핸들 바',
        desc: '보다 안정적인 주행 포지션을 고려한 핸들 바를 채용하여<br/>고정된 그립감과 다양한 악세사리를 장착할 수 있는 공간을 제공합니다.',
    },
    {
        imgPcUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pc_3.png'),
        imgPadUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pad_3.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_three_swiper_mobile_3.png'),
        title: '편안한 주행을 위한 시트',
        desc: '인체 공학적인 설계가 들어간 EV-C1의 시트와<br/>744mm의 낮은 시트고는 언제나 편안한 라이딩 포지션을 제공합니다.',
    },
    {
        imgPcUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pc_4.png'),
        imgPadUrl: require('assets/images/scooter/evc1/evc1_three_swiper_pad_4.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_three_swiper_mobile_4.png'),
        title: '전후방에 적용된 LED',
        desc: 'DRL/포지셔닝/턴시그널 램프에 LED램프를 장착하여<br/>주변을 환하게 밝히고 운전자의 전/후방 시야를 확보합니다.',
    },
]

/**
 * @constant COMFORTABLE_SWIPER_INFO ev-c1 화면 스와이퍼
 * @type imgUrl 이미지 url
 * @type title 제목
 * @type desc desc
 */
export const COMFORTABLE_SWIPER_INFO = [
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_four_swiper_pc_1.png'),
        imgUrlPcHover: require('assets/images/scooter/evc1/evc1_four_swiper_pc_hover_1.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_four_swiper_pad_1.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_four_swiper_mobile_1.png'),
        numbering: '01',
        title: 'BOSCH 10.1 ABS 시스템',
        desc: '초당 200회의 빈도로 전,후륜을 모니터링하고 휠 잠김을 방지하는<br/>BOSCH 10.1 ABS 브레이크 시스템을 채용하여 안전한 주행이 가능합니다.',
        descMobile:
            '초당 200회의 빈도로 전,후륜을 모니터링하고<br/>휠 잠김을 방지하는 BOSCH 10.1 ABS 브레이크<br/>시스템을 채용하여 안전한 주행이 가능합니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_four_swiper_pc_2.png'),
        imgUrlPcHover: require('assets/images/scooter/evc1/evc1_four_swiper_pc_hover_2.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_four_swiper_pad_2.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_four_swiper_mobile_2.png'),
        numbering: '02',
        title: '흔들림에도 강한 서스펜션',
        desc: '노면에서 전해지는 충격을 최대로 흡수하는<br/>Dual Shock Absorber를 적용하여 차원이 다른 승차감을 선사합니다.',
        descMobile:
            '노면에서 전해지는 충격을 최대로 흡수하는<br/>Dual Shock Absorber를 적용하여 차원이 다른<br/>승차감을 선사합니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_four_swiper_pc_3.png'),
        imgUrlPcHover: require('assets/images/scooter/evc1/evc1_four_swiper_pc_hover_3.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_four_swiper_pad_3.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_four_swiper_mobile_3.png'),
        numbering: '03',
        title: '안정감 있는 휠베이스',
        desc: '주행안정성을 극대화한 긴 휠베이스 설계로<br/>무거운 짐을 적재하거나 2인 탑승 시에도 안정적인 주행을 유지합니다.',
        descMobile:
            '주행안정성을 극대화한 긴 휠베이스 설계로<br/>무거운 짐을 적재하거나 2인 탑승 시에도<br/>안정적인 주행을 유지합니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_four_swiper_pc_4.png'),
        imgUrlPcHover: require('assets/images/scooter/evc1/evc1_four_swiper_pc_hover_4.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_four_swiper_pad_4.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_four_swiper_mobile_4.png'),
        numbering: '04',
        title: '진동을 최소화한 설계',
        desc: 'EV-C1의 핸들바는 추가 악세사리를 장착할 수 있는 넓은 공간을 제공하며<br/>단단한 핸들바 브라켓 장착으로 진동의 양을 줄이고 편안함을 높였습니다.',
        descMobile:
            'EV-C1의 핸들바는 추가 악세사리를 장착할 수 있는<br/>넓은 공간을 제공하며 단단한 핸들바 브라켓<br/>장착으로 진동의 양을 줄이고 편안함을 높였습니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_four_swiper_pc_5.png'),
        imgUrlPcHover: require('assets/images/scooter/evc1/evc1_four_swiper_pc_hover_5.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_four_swiper_pad_5.png'),
        imgMoUrl: require('assets/images/scooter/evc1/evc1_four_swiper_mobile_5.png'),
        numbering: '05',
        title: '완성도 높은 G2 모터',
        desc: '강력한 수냉식 영구 자석모터를 사용하여<br/>내연기관을 능가하는 주행 성능을 제공합니다.',
        descMobile: '강력한 수냉식 영구 자석모터를 사용하여<br/>내연기관을 능가하는 주행 성능을 제공합니다.',
    },
]

/**
 * @constant SIMPLE_SWIPER_INFO ev-c1 화면 스와이퍼
 * @type imgUrl 이미지 url
 * @type title 제목
 * @type desc desc
 */
export const SIMPLE_SWIPER_INFO = [
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_five_swiper_pc_1.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_five_swiper_pad_1.png'),
        imgUrlMo: require('assets/images/scooter/evc1/evc1_five_swiper_mobile_1.png'),
        title: '크루징 발판',
        desc: '발착지성을 높인 사선 라인의 넓은 발판은 라이더의<br/>편안한 승차자세를 유지할 수 있도록 도와줍니다.',
        descMobile:
            '발착지성을 높인 사선 라인의 넓은 발판은<br/>라이더의 편안한 승차자세를 유지할 수 있도록<br/>도와줍니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_five_swiper_pc_2.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_five_swiper_pad_2.png'),
        imgUrlMo: require('assets/images/scooter/evc1/evc1_five_swiper_mobile_2.png'),
        title: '25L 하단 시트 트렁크',
        desc: '25L의 수납 용량을 갖춘 트렁크는 헬맷을 포함한<br/>다양한 물품을 수납할 수 있는 넉넉한 공간을 제공합니다.',
        descMobile:
            '25L의 수납 용량을 갖춘 트렁크는 헬맷을<br/>포함한 다양한 물품을 수납할 수 있는<br/>넉넉한 공간을 제공합니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_five_swiper_pc_3.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_five_swiper_pad_3.png'),
        imgUrlMo: require('assets/images/scooter/evc1/evc1_five_swiper_mobile_3.png'),
        title: '전면 수납공간과 USB 포트',
        desc: '간단한 소지품도 수납 가능한 글러브 박스를 좌측에 장착하여 추가<br/>수납공간을 마련하고 좌측에 스마트폰을 충전을 위한 소켓을 마련했습니다.',
        descMobile:
            '간단한 소지품도 수납 가능한 글러브 박스를<br/>좌측에 장착하여 추가 수납공간을 마련하고<br/>좌측에 스마트폰을 충전을 위한 소켓을 마련했습니다.',
    },
]

/**
 * @constant CONNECTED_SWIPER_INFO ev-c1 화면 스와이퍼
 * @type imgUrl 이미지 url
 * @type title 제목
 * @type desc desc
 */
export const CONNECTED_SWIPER_INFO = [
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_eight_swiper_pc_1.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_eight_swiper_pad_1.png'),
        imgUrlMo: require('assets/images/scooter/evc1/evc1_eight_swiper_mobile_1.png'),
        numbering: '01',
        title: 'CROXERA 어플을 통한 스마트 단축키 설정으로<br/>사용자가 설정한 목적지로 빠르게 안내합니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_eight_swiper_pc_2.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_eight_swiper_pad_2.png'),
        imgUrlMo: require('assets/images/scooter/evc1/evc1_eight_swiper_mobile_2.png'),
        numbering: '02',
        title: '차량별 설정을 통한 맞춤 경고음 설정과<br/>실시간 상태를 파악할 수 있는 데이터를 제공합니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_eight_swiper_pc_3.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_eight_swiper_pad_3.png'),
        imgUrlMo: require('assets/images/scooter/evc1/evc1_eight_swiper_mobile_3.png'),
        numbering: '03',
        title: '스마트 키가 없어도 자유자재로 시동을 켜고<br/>끌 수 있는 원격시동 기능을 제공합니다.',
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_eight_swiper_pc_4.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_eight_swiper_pad_4.png'),
        imgUrlMo: require('assets/images/scooter/evc1/evc1_eight_swiper_mobile_4.png'),
        numbering: '04',
        title: '운동에너지를 전기에너지로 변환하는<br/>회생제동 기능으로 배터리 효율을 극대화합니다.',
    },
]

/**
 * @constant EVC1_SCOOTER_IMG_SWIPER_INFO ev-c1 화면 스와이퍼
 * @type imgUrl 이미지 url
 * @type title 제목
 * @type desc desc
 */
export const EVC1_SCOOTER_IMG_SWIPER_INFO = [
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_info_white_pc.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_info_white_pad.png'),
        imgUrlMobile: require('assets/images/scooter/evc1/evc1_info_white_mobile.png'),
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_info_gray_pc.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_info_gray_pad.png'),
        imgUrlMobile: require('assets/images/scooter/evc1/evc1_info_gray_mobile.png'),
    },
    {
        imgUrlPc: require('assets/images/scooter/evc1/evc1_info_black_pc.png'),
        imgUrlPad: require('assets/images/scooter/evc1/evc1_info_black_pad.png'),
        imgUrlMobile: require('assets/images/scooter/evc1/evc1_info_black_mobile.png'),
    },
]

/**
 * @constant EVC1_SCOOTER_INFO ev-c1 화면 제원
 */
export const EVC1_SCOOTER_INFO = {
    //차체제원
    SCOOTER_SPECIFI: {
        SCOOTER_SPECIFI_TEXT: '차체 제원',
        COLOR_TEXT: '색상', //색상
        COLOR: '오로라 화이트 / 실버 그레이 / 건 블랙', //색상
        SIZE_TEXT: '차량 사이즈', //차량사이즈
        SIZE: '1,880 X 760 X 1,140mm', //차량사이즈
        WEIGHT_TEXT: '중량', //중량
        WEIGHT: '140kg', //중량
        TRUNK_CAPACITY_TEXT: '트렁크 용량', //트렁크용량
        TRUNK_CAPACITY: '25L', //트렁크용량
    },
    //기본제원
    BASIC_SPECIFI: {
        BASIC_SPECIFI_TEXT: '기본 제원',

        MAX_OUTPUT_TEXT: '최대 출력', //최대 출력
        MAX_OUTPUT: '7.2kW @ 3,000rpm', //최대 출력

        MAX_TORQUE_TEXT: '최대 토크', //최대 토크
        MAX_TORQUE: '26 / 205 Nm @ 2,500rpm', //최대 토크

        ABILITY_TEXT: '등판 능력', //등판 능력
        ABILITY: '30% (17°) : 40km/h, 20% (11°) : 50km/h, 10% (6°) : 70km/h', //등판 능력

        MAX_MILE_TEXT: '완충 기준 최대 주행거리', //완충 기준 최대 주행거리
        MAX_MILE: '30km/h 정속 주행 시 170km', //완충 기준 최대 주행거리

        DRIVING_MODE_TEXT: '주행 모드', //주행 모드
        DRIVING_MODE: '스탠다드 모드 / 스마트 모드 / 스포츠 모드 / 슈퍼 부스트 모드', //주행 모드

        REVERSE_TEXT: '후진 기능', //후진 기능
        REVERSE: '지원', //후진 기능
    },
    //안전기능
    SAFETY_SPECIFI: {
        SAFETY_SPECIFI_TEXT: '안전 기능',

        LOCK_TEXT: '차량 잠금 기능', //차량 잠금 기능
        LOCK: '스마트 키카드 / 스마트폰 / 애플워치', //차량 잠금 기능

        REAR_SHOCK_TEXT: '리어 쇼크 업쇼버 (쇼바)', //리어 쇼크 업쇼버 (쇼바)
        REAR_SHOCK: '듀얼 쇼크 업소버 (쇼바)', //리어 쇼크 업쇼버 (쇼바)

        BRAKE_SYSTEAM_TEXT: '브레이크 시스템/브레이크 보조 시스템', //브레이크 시스템/브레이크 보조 시스템
        BRAKE_SYSTEAM: '디스크 브레이크 / ABS', //브레이크 시스템/브레이크 보조 시스템

        BRAKE_CALIPER_TEXT: '브레이크 캘리퍼(전/후)', //브레이크 캘리퍼(전/후)
        BRAKE_CALIPER: '듀얼 피스톤 / 싱글 피스톤', //브레이크 캘리퍼(전/후)

        HEADLIGHT_TEXT: '헤드라이트', //헤드라이트
        HEADLIGHT: 'LED 헤드라이트', //헤드라이트

        TAILLIGHT_TEXT: '테일라이트', //테일라이트
        TAILLIGHT: 'LED 후미등 및 방향지시등', //테일라이트

        TURN_SIGNAL_TEXT: '전방방향 지시등', //전방방향 지시등
        TURN_SIGNAL: 'LED', //전방방향 지시등
    },
}
